import React, { PureComponent } from 'react'
import { Panel, Button } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputCheckbox from '../../../../components/commons/form/InputCheckBox'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import { compareValues } from '../../../../util/utils'
import { Link } from 'react-router-dom'
import InputSelect from '../../../../components/commons/form/InputSelect'
import { operationTabs } from '../../../../constants/management/operations'
import { permissions } from '../../../../constants/backendIds'
import { dossierSubTypeId } from '../../../../constants/dossier/common/dossierSubType'
import { fleetsTab } from '../../../../constants/management/fleets'

class PaperworkFleetListComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openPaperworkPanel: false,
      dossiersLoaded: false,
      filters: {
        orderBy: '+number',
        selectedCheck_massive: false
      }
    }
  }

  componentDidMount () {
    if (this.props.fleet && !this.props.create && this.state.openPaperworkPanel) {
      this.props.actions.getDossierChildSubtypeDetailCount(this.props.fleet.fleetId, dossierSubTypeId.tramite)
      this.props.actions.getPaperworksDetailsFleet(this.props.fleet.fleetId)
      this.setState({ dossiersLoaded: true })
      if (this.props.dataPaperWorkActions.length === 0 || this.props.operationPaperWorkActions.length === 0) {
        this.props.actions.getFleetOperations()
      }
    }
  }

  collapsePanelDossier () {
    var newState = !this.state.openPaperworkPanel
    this.setState({ openPaperworkPanel: newState })
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.fleet && !this.props.create && ((this.props.tabActiveKey !== prevProps.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_DOSSIERS && this.state.openPaperworkPanel) || (this.props.tabActiveKey === fleetsTab.FLEETS_DOSSIERS && this.state.openPaperworkPanel && this.state.openPaperworkPanel !== prevState.openPaperworkPanel))) {
      this.props.actions.getDossierChildSubtypeDetailCount(this.props.fleet.fleetId, dossierSubTypeId.tramite)
      this.props.actions.getPaperworksDetailsFleet(this.props.fleet.fleetId)
      this.setState({ dossiersLoaded: true, selectedCheck_massive: false })
      if (this.props.dataPaperWorkActions.length === 0 || this.props.operationPaperWorkActions.length === 0) {
        this.props.actions.getFleetOperations()
      }
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.changeCheckAll !== prevProps.changeCheckAll) {
      this.setState({ selectedCheck_massive: false })
    }
    return null
  }

  refresh () {
    this.props.actions.getDossierChildSubtypeDetailCount(this.props.fleet.fleetId, dossierSubTypeId.tramite)
    this.props.actions.getPaperworksDetailsFleet(this.props.fleet.fleetId)
    this.setState({ selectedCheck_massive: false })
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let dossiers = JSON.parse(JSON.stringify(this.props.paperWorkFleetDetails))
    dossiers = dossiers.sort(compareValues(field, order))
    this.props.actions.getPaperworksDetailsFleetSuccess(dossiers)
  }

  onCheckAll (e) {
    this.setState({ selectedCheck_massive: e })
    let dossiers = JSON.parse(JSON.stringify(this.props.paperWorkFleetDetails))

    dossiers.map(dossier => {
      dossier.checked = e
    })

    this.props.actions.getPaperworksDetailsFleetSuccess(dossiers)
    this.props.documentsAllSelected(e)
  }

  onCheckOne (e, id) {
    this.setState({ selectedCheck_massive: false })
    let dossiers = JSON.parse(JSON.stringify(this.props.paperWorkFleetDetails))

    dossiers.map(dossier => {
      if (dossier.dossierId === id) {
        dossier.checked = e
      }
    })

    this.props.actions.getPaperworksDetailsFleetSuccess(dossiers)
    if (dossiers.filter(dossier => dossier.checked).length === dossiers.length) {
      this.props.documentsAllSelected(true)
      this.setState({ selectedCheck_massive: true })
    } else {
      this.props.documentsAllSelected(false)
      this.setState({ selectedCheck_massive: false })
    }
  }

  render () {
    const {
      t,
      paperWorkFleetDetails,
      readOnlyFields,
      dataPaperWorkActions,
      operationPaperWorkActions,
      fleet,
      paperWorkCount
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const numDossiers = !this.state.dossiersLoaded ? '' : (paperWorkCount || 0)
    const selectedDossiers = this.props.paperWorkFleetDetails.filter(dossier => dossier.checked)
    let bar = !this.state.dossiersLoaded ? '' : ' | '
    let columnsTable = [
      <th key={0} data-field="number" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}DOSSIER_NUMBER`)}&nbsp;<i className={this.getIconClass('number')}></i>
      </th>,
      <th key={1} data-field="organizedUnit" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}ORGANIZED_UNIT`)}&nbsp;<i className={this.getIconClass('organizedUnit')}></i>
      </th>,
      <th key={3} data-field="vehicle" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}VEHICLE`)}&nbsp;<i className={this.getIconClass('vehicle')}/>
      </th>,
      <th key={4} data-field="model" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}MODEL`)}&nbsp;<i className={this.getIconClass('model')}></i>
      </th>,
      <th key={5} data-field="paperWorkType" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}PAPERWORK_TYPE`)}&nbsp;<i className={this.getIconClass('paperWorkType')}></i>
      </th>,
      <th key={6} data-field="stage" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}STAGE`)}&nbsp;<i className={this.getIconClass('stage')}/>
      </th>,
      <th key={7} data-field="processingAgencyName" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}PROCESSING_AGENCY`)}&nbsp;<i className={this.getIconClass('processingAgencyName')}/>
      </th>
    ]
    if (!readOnlyFields) {
      columnsTable.push(
        <th key={8} data-field="checked" className='flet-detail-dossier-check-title' >
          <Field
            component={InputCheckbox}
            id='selectedCheck_massive_paperwork'
            name={'selectedCheck_massive_paperwork'}
            onChange={(event) => this.onCheckAll(event)}
            checked={this.state.selectedCheck_massive}
          />
        </th>
      )
    }

    return (
      <>
        <div id="paperworkFleetListComponent" className="_nf dossier-panel" >
          <div id="paperWorkFleetHeader" className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelDossier()}>

            <div className="name-wrapper fleet-panel-box-title">
              <h4>{t(`${tKey}PAPERWORKS`)} {bar} <span className='fleet-panel-subTitle'>{numDossiers}</span> </h4>
            </div>

            <i id="paperWorkFleetArrow" className={this.state.openPaperworkPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />

          </div>
          <Panel expanded={this.state.openPaperworkPanel} onToggle={() => {}}>
            <Panel.Collapse>
              <div id="fleet-dossier-details-table">
                <div className='flexInLine al-R'>
                  {(this.props.fleet && !this.props.create && this.props.tabActiveKey === fleetsTab.FLEETS_DOSSIERS && this.state.openPaperworkPanel) &&
                    <Button
                      id="fleet-paperwork-details-refresh-button"
                      className="_Btn accept stk"
                      onClick = {() => this.refresh()}>
                      <i className='iDocIcon-update'></i>
                      {t(`${tKey}AUX_MODALS.REFRESH`)}
                    </Button>
                  }
                </div>
                <SimpleTablePage
                  columns={columnsTable}
                  rows={paperWorkFleetDetails && paperWorkFleetDetails.map((row, idx) => (
                    <tr key={idx}>
                      <td>
                        {
                          row.urlToNavigate && row.stageId ? (
                            <Link to={`/dossier${row.urlToNavigate}`}>
                              {row.number}
                            </Link>
                          ) : row.number
                        }
                      </td>
                      <td>{row.organizedUnit}</td>
                      <td>{row.vehicle}</td>
                      <td>{row.model}</td>
                      <td>{row.paperWorkType}</td>
                      <td>{row.stage}</td>
                      <td>{row.processingAgencyName}</td>
                      {!readOnlyFields && <td>{<Field
                        component={InputCheckbox}
                        name={'selectedCheckPW_' + idx}
                        id={'selectedCheckPW_' + idx}
                        checked={row.checked ? row.checked : false}
                        onChange={(event) => this.onCheckOne(event, row.dossierId)}
                      />}
                      </td>}
                    </tr>
                  ))}

                ></SimpleTablePage>
              </div>
              {!readOnlyFields && (
                <div className='actionsLine'>
                  <Field
                    component={InputSelect}
                    colWidth={50} // 25, 33, 50, 75, 100 default=25
                    id="paperworkFleet_paperWorkDataId"
                    name='paperWorkDataId'
                    placeholder={t(`${tKey}DATA`)}
                    controlLabel={t(`${tKey}DATA`)}
                    options={dataPaperWorkActions}
                    valueKey="managementActionId"
                    labelKey="name"
                    disabled={selectedDossiers.length === 0}
                    onInputChange={(val) => { document.activeElement?.blur(); this.props.launchAction(val, operationTabs.DATA_PAPERWORK, this.props.paperWorkFleetDetails.filter(dossier => dossier.checked)); this.props.change('paperWorkDataId', null) }}
                  />
                  <Field
                    component={InputSelect}
                    colWidth={50} // 25, 33, 50, 75, 100 default=25
                    id="paperworkFleet_paperWorkActionId"
                    name='paperWorkActionId'
                    placeholder={t(`${tKey}ACTIONS`)}
                    controlLabel={t(`${tKey}ACTIONS`)}
                    options={operationPaperWorkActions}
                    valueKey="managementActionId"
                    labelKey="name"
                    disabled={selectedDossiers.length === 0}
                    onInputChange={(val) => { this.props.launchAction(val, operationTabs.OPERATIONS_PAPERWORK, this.props.paperWorkFleetDetails.filter(dossier => dossier.checked)); this.props.change('paperWorkActionId', null) }}
                  />
                  {this.props.fieldsConfiguration && this.props.fieldsConfiguration.documentsFleet && this.props.fieldsConfiguration.documentsFleet.permission === permissions.editable && (
                    <Button
                      id='paperworkFleet_paperWorkDocumentButton'
                      className="_Btn accept"
                      onClick={() => this.props.openDocumentsModal(fleet, selectedDossiers)}
                      disabled={selectedDossiers.length === 0}>
                      {t(`${tKey}DOCUMENTS`)}
                    </Button>)}

                </div>
              )}

            </Panel.Collapse>
          </Panel>
        </div>

      </>
    )
  }
}

export default reduxForm({
  form: 'PaperworkFleetListComponent'
})(PaperworkFleetListComponent)
